const CLEANUP_DELAY = 100; // ms

export class LocalDownloader {
    public static downloadBlob(blob: unknown, filename?: string): void {
        if (!(blob instanceof Blob || blob instanceof MediaSource)) {
            throw new Error(`Data is of invalid type, expected Blob but got: ${typeof blob}`);
        }

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        if ('undefined' !== typeof window.navigator.msSaveBlob) {
            // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which
            // they were created. These URLs will no longer resolve as the data backing the URL has been
            // freed."
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call
            window.navigator.msSaveBlob(blob, filename);

            return;
        }

        const URL = window.URL || window.webkitURL;
        const downloadUrl = URL.createObjectURL(blob);

        if (filename) {
            // use HTML5 a[download] attribute to specify filename
            const a = document.createElement('a');
            // safari doesn't support this yet
            if ('undefined' === typeof a.download) {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        } else {
            window.location.href = downloadUrl;
        }

        setTimeout(() => URL.revokeObjectURL(downloadUrl), CLEANUP_DELAY); // cleanup
    }
}
